import * as React from 'react';
export const IcFirefighterOfficer = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 11c3.87 0 7-1.34 7-3 0-.94-1-1.78-2.58-2.33a4.5 4.5 0 00-8.84 0C6 6.22 5 7.06 5 8c0 1.66 3.13 3 7 3zm0-7a1 1 0 110 2 1 1 0 010-2zm2.47 8.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM9 20H7a1 1 0 010-2h2a1 1 0 010 2zm7 0a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
